import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { singleUser } from "../../../states/actions/loginAction";
import { useDispatch, useSelector } from "react-redux";
import Logout from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import BaseUrl from "../../../service/API/base_url";
import { useTranslation } from "react-i18next";

const ProfileMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };
  const handleProfile = () => {
    navigate("/setting");
  };

  const Role = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  function parseJWT(token) {
    if (Role !== null && Role !== undefined) {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    }
  }
  const userInfo = parseJWT(Role);
  useEffect(() => {
    dispatch(singleUser(userInfo?.id));
  }, []);
  const userLogin = useSelector((state) => state.userLogin);

  const [picture, setPicture] = useState(null);
  useEffect(() => {
    if (
      userLogin?.userLogin?.length !== null &&
      userLogin?.userLogin !== undefined
    ) {
      setPicture(userLogin?.userLogin?.photo1);
    }
  }, [userLogin?.userLogin]);
  const { t: translate } = useTranslation(["loginAndregister"]);
  return (
    <>
      <Tooltip title="Account settings" arrow>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          {picture ? (
            <Avatar
              sx={{ width: 32, height: 32 }}
              src={`${BaseUrl}${picture}`}
            />
          ) : (
            <Avatar
              sx={{ width: 32, height: 32 }}
              src="/images/avatars/dr-tesfaye.jpg"
            />
          )}
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleProfile}>
          <Avatar />
          {translate("Profile")}
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          {translate("Logout")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ProfileMenu;
